import React from "react";
import { BasicLayout } from "./components/layout";

function App() {
    return (
        <div className="flex" >
            {/* <IconSidebar /> */}
            <BasicLayout />
        </div>
    );
}

export default App;
